// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"93d0de6a","227":"536c5f1b","453":"78de8f96","560":"e72f9fc0","648":"ccd31179"}[chunkId] + ".chunk.js";
};